<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="12%")
          span(:title="$t('ui.date_time')") {{ $t('ui.date_time') }}
        th(width="10%")
          span {{ $t('ui.ip') }}
        th(width="10%")
          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
        th(width="10%")
          span(:title="$t('ui.sports_game')") {{ $t('ui.sports_game') }}
        th(width="15%")
          span(:title="$t('ui.event')") {{ $t('ui.event') }}
        th(width="10%")
          span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
        th.text-right(width="10%")
          span(:title="$t('ui.bet_amount')") {{ $t('ui.bet_amount') }}
        //- th.text-right(width="10%")
        //-   span(:title="$t('ui.actual_bet_amount')") {{ $t('ui.actual_bet_amount') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="7").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
        td
          span(:title="item.ip") {{ item.ip }}
        td
          span(:title="item.member_id") {{ item.member_id }}&nbsp;
        td
          //- span(:title="item.sports_type") {{ item.sports_type }}
          //- br
          span(:title="item.sports_category") {{ item.sports_category }}&nbsp;
          br
          span(:title="item.game_type_name") {{ item.game_type_name }}&nbsp;
        td
          template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
            small {{  item.provider_code }}
            template(v-if="item.bet_type != 'PARLAY'")
              span.font-weight-bold(:title="item.league_name") {{ item.league_name }}&nbsp;
              template(v-if="item.home_team_name != null && item.away_team_name != null")
                br
                span.text-success(:title="item.home_team_name") {{ item.home_team_name  }}&nbsp;
                span vs&nbsp;
                span.text-danger(:title="item.away_team_name") {{ item.away_team_name }}&nbsp;
              br
              span.text-info(:title="$moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss') }}
              span.text-primary(v-if="item.home_score != null && item.away_score != null" :title="'(' + item.home_score + ' - ' + item.away_score + ')'") {{ '(' + item.home_score + ' - ' + item.away_score + ')' }}
            template(v-else)
              span.font-weight-bold(:title="$t('ui.mix_parlay')") {{ $t("ui.mix_parlay") }}
              br
              span(:title="item.odds_display_bet") {{ item.odds_display_bet }}&nbsp;                      
        td
          template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
            span(:title="item.bet_type") {{ item.bet_type }}&nbsp;
            br
            span(:title="item.bet_hand") {{ item.bet_hand }}&nbsp;
            br
            span(v-if="item.odds_display != null" :title="item.odds_display + ' ' + getOddsType(item.odds_type)") {{ item.odds_display + ' ' + getOddsType(item.odds_type) }}&nbsp;
          //- template(v-else)
          //-   i.fas.fa-comment-dots.text-primary(
          //-     role="button"
          //-     :title="$t('ui.remark')"
          //-     style="cursor: pointer;"
          //-     @click="openRemarkModal(item.remark, item.provider_code)"
          //-   )
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.bet_amount)" :title="$n(item.bet_amount, 'currency')") {{ $n(item.bet_amount, 'currency') }}
        //- td.text-right
        //-   span.font-weight-bold(:class="$helpers.fontClassName(item.actual_bet_amount)" :title="$n(item.actual_bet_amount, 'currency')") {{ $n(item.actual_bet_amount, 'currency') }}
      tr.footer
        td.text-right(colspan="7")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBetAmount)" :title="$n(subTotalBetAmount, 'currency')") {{ $n(subTotalBetAmount, 'currency') }}
        //- td.text-right
        //-   span.font-weight-bold(:class="$helpers.fontClassName(subTotalActualBetAmount)" :title="$n(subTotalActualBetAmount, 'currency')") {{ $n(subTotalActualBetAmount, 'currency') }}

      tr.footer
        td.text-right(colspan="7")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBetAmount)" :title="$n(grandTotalBetAmount, 'currency')") {{ $n(grandTotalBetAmount, 'currency') }}
        //- td.text-right
        //-   span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActualBetAmount)" :title="$n(grandTotalActualBetAmount, 'currency')") {{ $n(grandTotalActualBetAmount, 'currency') }}

</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalBetAmount: 0,
    grandTotalBetAmount: 0,
    subTotalActualBetAmount: 0,
    grandTotalActualBetAmount: 0,
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    getOddsType(n) {
      var result = "";
      switch(n) {
        case 1:
          result = "(MY)";
          break;
        case 2:
          result = "(HK)";
          break;
        case 3:
          result = "(ID)";
          break;
        case 4:
          result = "(DEC)";
          break;
      }
      return result;
    },
    clearTotal() {
      this.subTotalBetAmount = 0
      this.grandTotalBetAmount = 0
      this.subTotalActualBetAmount = 0
      this.grandTotalActualBetAmount = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalBetAmount = parseFloat(this.subTotalBetAmount) + parseFloat(value["bet_amount"]);
          this.subTotalActualBetAmount = parseFloat(this.subTotalActualBetAmount) + parseFloat(value["actual_bet_amount"]);

        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalBetAmount = totalTbl[0]["bet_amount"];
          this.grandTotalActualBetAmount = totalTbl[0]["actual_bet_amount"];
        }
      }
    }
  }
};
</script>
